import { motion } from "framer-motion";

export function StatCard({ label, value, sub, icon: Icon, tone = "default", testId, index = 0 }) {
  const toneClass =
    tone === "good" ? "text-emerald-300" : tone === "warn" ? "text-amber-300" : tone === "accent" ? "text-electric" : "text-white";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05, duration: 0.25 }}
      data-testid={testId}
      className="bz-card hover:border-electric/30"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="bz-caption">{label}</p>
        {Icon ? <Icon className="h-4 w-4 text-slate-500" strokeWidth={1.75} /> : null}
      </div>
      <p className={`mt-4 font-display text-2xl font-bold tracking-tight ${toneClass}`}>{value}</p>
      {sub ? <p className="mt-1 text-xs text-slate-500">{sub}</p> : null}
    </motion.div>
  );
}

export function SectionHeading({ title, description, action }) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="font-display text-base font-semibold tracking-tight text-white md:text-lg">{title}</h2>
        {description ? <p className="mt-1 text-sm text-slate-400">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ children, testId }) {
  return (
    <div data-testid={testId} className="rounded-md border border-dashed border-white/10 px-4 py-8 text-center text-sm text-slate-500">
      {children}
    </div>
  );
}
